import { Component, Input, Output, EventEmitter } from "@angular/core";
import { EmbargoManagementPageDataService } from "../embargo-management-page-data.service";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-embargo-delete-modal",
  templateUrl: "./embargo-delete-modal.component.html",
  styleUrls: ["./embargo-delete-modal.component.scss"],
})
export class EmbargoDeleteModalComponent {
  constructor(
    private dataService: EmbargoManagementPageDataService,
    private message: NzMessageService,
  ) {}

  @Input() deleteData;
  @Input() showModal = false;
  @Input() count;
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() triggerFetchGridAfterDelete = new EventEmitter();

  handleCancelForEmbargoDelete() {
    this.closeModal.emit(false);
  }

  handledelete() {
    const deleteArray = Array.from(this.deleteData);
    const inputData = [];
    deleteArray.forEach(function (d) {
      inputData.push({ broker_id: d["brokerId"], buyside_id: d["buysideId"] });
    });
    this.dataService.deleteEmbargoDetails(inputData).subscribe(
      (data) => {
        this.triggerFetchGridAfterDelete.emit();
        this.message.create("success", `${data}`);
      },
      (err) => {
        this.message.create("error", `${err["error"]["errors"]}`);
      },
    );
  }
}
